import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { changePassword } from '@/api/services/auth.service'
import { getErrorMessage } from '@/lib/getErrorMessage'
import type { ChangePasswordRequest } from '@/types/api.types'

/**
 * Mutation hook for changing the current user's password.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: (body: ChangePasswordRequest) => changePassword(body),
    onSuccess: () => {
      toast.success('Password updated')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}
